import * as React from "react";
import {
    Box,
    MenuItem,
    Select,
    IconButton,
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";

const RangePicklist = ({ label, hideLabel, value, options, onChange, ...rest }) => {
    const [selectOpen, setSelectOpen] = React.useState({});
    const handleChange = (event, selectedValue, key) => {
        value[key] = selectedValue;
        if (!selectedValue) {
            delete value[key];
        }

        onChange(event, value);
    };

    const handleSelectClick = (event, selectValue) => {
        event.stopPropagation();
        event.preventDefault();
        const data = {};
        data[selectValue] = true;
        setSelectOpen(data);
    };

    const handleSelectClose = () => {
        const data = {};
        setSelectOpen(data);
    };

    const getMinOption = () => {
        if (value.max) {
            return options.filter((item) => parseInt(item.value) < parseInt(value.max));
        }
        return options;
    };

    const getMaxOption = () => {
        if (value.min) {
            return options.filter((item) => parseInt(item.value) > parseInt(value.min));
        }
        return options;
    };

    return (
        <FormControl component="fieldset" rest sx={{ width: "100%" }}>
            {!hideLabel && (
                <FormLabel sx={{ mb: ".5rem" }} component="legend">
                    {label}
                </FormLabel>
            )}
            <FormGroup>
                <Grid container justifyContent={"space-between"} alignItems={"center"} spacing={1}>
                    <Grid item xs={6}>
                        <Select
                            labelId="min-select-label"
                            id="min-select"
                            fullWidth
                            value={value.min ? options.find((item) => item.value === value.min).label : "-"}
                            label=""
                            IconComponent={value.min ? "" : ArrowDropDownIcon}
                            renderValue={(selected) => {
                                if (selected === "-") {
                                    return <em style={{ color: "gray" }}>No Min</em>;
                                }

                                return selected;
                            }}
                            open={selectOpen.min ? selectOpen.min : false}
                            onClick={(event) => handleSelectClick(event, "min")}
                            onClose={handleSelectClose}
                            endAdornment={
                                value.min && (
                                    <IconButton onClick={(event) => handleChange(event, "", "min")}>
                                        <CloseIcon />
                                    </IconButton>
                                )
                            }>
                            <MenuItem onClick={(event) => handleChange(event, "", "min")} value="">
                                <em>No Min</em>
                            </MenuItem>
                            {getMinOption().map((item) => (
                                <MenuItem
                                    onClick={(event) => handleChange(event, item.value, "min")}
                                    value={item.value}>
                                    {item.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item xs={6}>
                        <Select
                            labelId="max-select-label"
                            id="max-select"
                            value={value.max ? options.find((item) => item.value === value.max).label : "-"}
                            label=""
                            fullWidth
                            IconComponent={value.max ? "" : ArrowDropDownIcon}
                            renderValue={(selected) => {
                                if (selected === "-") {
                                    return <em style={{ color: "gray" }}>No Max</em>;
                                }

                                return selected;
                            }}
                            open={selectOpen.max ? selectOpen.max : false}
                            onClick={(event) => handleSelectClick(event, "max")}
                            onClose={handleSelectClose}
                            endAdornment={
                                value.max && (
                                    <IconButton onClick={(event) => handleChange(event, "", "max")}>
                                        <CloseIcon />
                                    </IconButton>
                                )
                            }>
                            <MenuItem onClick={(event) => handleChange(event, "", "max")} value="">
                                <em>No Max</em>
                            </MenuItem>
                            {getMaxOption().map((item) => (
                                <MenuItem
                                    onClick={(event) => handleChange(event, item.value, "max")}
                                    value={item.value}>
                                    {item.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                </Grid>
            </FormGroup>
        </FormControl>
    );
};

export { RangePicklist };
